import { render, staticRenderFns } from "./OrderProductItem.vue?vue&type=template&id=0ad65457&"
import script from "./OrderProductItem.vue?vue&type=script&lang=js&"
export * from "./OrderProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports